import BetechHero from "./BetechHero";

export default BetechHero;